import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';

class SpanButton extends PureComponent {
  render() {
    return (
      <span {...this.props}>
        { this.props.children}
      </span>
    );
  }
}

/**
 * This is a custom pagination component used for dugout-common's PaginatedCFTable
 * The props it receives are passed to it from the react-table package, so you simply pass
 * it as a prop: paginationComponent={CustomPaginationFooter}
 */
export default class CustomPaginationFooter extends Component {
  state = { page: this.props.page }

  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      this.setState({ page: this.props.page });
    }
  }

  changePage = page => {
    const activePage = this.props.page + 1;
    if (page === activePage) return;
    const pageChange = page === 1 ? 0 : page - 2;
    this.props.onPageChange(pageChange);
    this.setState({ page: page - 1 });
  }

  render() {
    const {
      data, page, pages,
      NextComponent = SpanButton,
      PreviousComponent = SpanButton,
    } = this.props;
    const { changePage } = this;

    const activePage = page + 1;
    const visiblePage = this.state.page ? this.state.page : page;

    const showFooter = data.length > 0;

    return showFooter ? (
      <div className="coachingtable__custom-footer">
        <div className="prev-buttons">
          <PreviousComponent
            className='first-button'
            onClick={() => {if (visiblePage !== 1) changePage(1)}}
            disabled={visiblePage === 1}
          >
            <span className={`${visiblePage === 1 ? 'disabled' : ''} -button -first`}>&#171;</span>
          </PreviousComponent>
          <PreviousComponent
            className='previous-button'
            onClick={() => { if (visiblePage !== 1) changePage(activePage - 1)}}
            disabled={visiblePage === 1}
          >
            <span className={`${visiblePage === 1 ? 'disabled' : ''} -button -previous`}>&#8249;</span>
          </PreviousComponent>
        </div>
        <div className="center">
          {`${visiblePage} of ${pages}`}
        </div>
        <div className='next-buttons'>
          <NextComponent
            className='next-button'
            onClick={() => { if (visiblePage !== pages) changePage(activePage + 1)}}
            disabled={visiblePage === pages}
          >
            <span className={`${visiblePage === pages ? 'disabled' : ''} -button -next`}>&#8250;</span>
          </NextComponent>
          <NextComponent
            className='last-button'
            onClick={() => { if (visiblePage !== pages) changePage(pages)}}
            disabled={visiblePage === pages}
          >
            <span className={`${visiblePage === pages ? 'disabled' : ''} -button -last`}>&#187;</span>
          </NextComponent>
        </div>
      </div>
    ) : (
      <div className="coachingtable__empty">
        No coaching opportunities available.
      </div>
    );
  }
}

CustomPaginationFooter.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  NextComponent: PropTypes.element,
  PreviousComponent: PropTypes.element,
}

CustomPaginationFooter.defaultProps = {
  NextComponent: SpanButton,
  PreviousComponent: SpanButton,
}


// WEBPACK FOOTER //
// ./src/features/agent-coaching/CustomPaginationFooter.js